export enum Steps {
  step0,
  step1,
  step2,
}

export enum errorTypes {
  deliveryType = "deliveryType",
  point = "point",
  name = "name",
  phone = "phone",
}

const initialState = {
  errors: [],
  basket: {},
  paymentList: [],
  deliveryList: [],
  deliveryListAdditional: [],
  deliveryListAdditionalLoaded: false,
  edostData: {},
  params: {},
  isParamsLoaded: false,
  isBasketLoading: false,
  isBasketLoaded: false,
  animation: "",
  step: Steps.step0,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
export const cartReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_ERRORS":
      return { ...state, errors: action.payload };
    case "SET_CART_PARAMS":
      return { ...state, params: action.payload };
    case "SET_CART_PARAMS_LOADED":
      return { ...state, isParamsLoaded: action.payload };
    case "SET_BASKET":
      return { ...state, basket: action.payload };
    case "SET_BASKET_LOADING":
      return { ...state, isBasketLoading: action.payload };
    case "SET_BASKET_LOADED":
      return { ...state, isBasketLoaded: action.payload };
    case "SET_DELIVERY_LIST":
      return { ...state, deliveryList: action.payload };
    case "SET_DELIVERY_LIST_ADDITIONAL":
      return { ...state, deliveryListAdditional: action.payload };
    case "SET_DELIVERY_LIST_ADDITIONAL_LOADED":
      return { ...state, deliveryListAdditionalLoaded: action.payload };
    case "SET_PAYMENT_LIST":
      return { ...state, paymentList: action.payload };
    case "SET_STEP":
      return { ...state, step: action.payload };
    case "SET_ANIMATION":
      return { ...state, animation: action.payload };
    default:
      return state;
  }
};
